import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Hammer } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileStickyBar from "../components/MobileStickyBar";
import Seo from "../components/Seo";
import { api, imgUrl, COMPANY } from "../lib/site";
import { useLang } from "../i18n/LanguageContext";

export default function Services() {
  const { t } = useLang();
  const { data: services = [] } = useQuery({ queryKey: ["services","list"], queryFn: async () => (await api.get("/services")).data });
  return (
    <div className="min-h-screen">
      <Seo title={`${t("nav.services")} | ${COMPANY.name}`} description={t("section.services.desc")} path="/tjenester" />
      <Header />
      <section className="section">
        <div className="container-page">
          <span className="eyebrow">{t("nav.services")}</span>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">{t("services.pageTitle")}</h1>
          <div className="dot-divider mt-4" />
          <p className="mt-5 max-w-2xl text-[#383E45] leading-relaxed">{t("section.services.desc")}</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => (
              <Link key={s.slug} to={`/tjenester/${s.slug}`} className="card-warm block" data-testid={`svc-${s.slug}`}>
                <div className="aspect-[16/10] overflow-hidden"><img src={imgUrl(s)} alt={s.title} className="w-full h-full object-cover" loading="lazy" /></div>
                <div className="p-5">
                  <div className="flex items-center gap-2"><Hammer size={16} className="text-[#1B3626]"/><h3 className="font-display font-bold text-[17px]">{s.title}</h3></div>
                  <p className="text-sm text-[#555E68] mt-1.5">{s.short}</p>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1B3626]">{t("cta.readMore")} <ArrowRight size={14}/></div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer /><MobileStickyBar />
    </div>
  );
}
